import { SpacingOptions } from '@mui/system';

export const uberThemeSpacings: SpacingOptions = [
  0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50,
];
